import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SupplierPortalSettings } from '../models/settings.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingsDataService {
  private readonly http = inject(HttpClient);

  loadSupplierPortalSettings(portal: string, supplierId: number | null) {
    return this.http.get<SupplierPortalSettings>(
      `${environment.CRD_API}v1/supplier-portal/${portal}/settings`,
      {
        headers: new HttpHeaders({ 'no-default-interceptor': '1' }),
        params: { supplier_id: String(supplierId) }
      }
    );
  }
}
